import type { FaireProductEntity } from "../../entity_types/product";

export const p_6vmsdtksv2: FaireProductEntity = {
  token: "p_6vmsdtksv2",
  type: "product",
  name: "Gingerbread Cookie - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/3b90cd467c9332e18b034e320251123a9bdf90939c14c6ee9e440572356dbe65.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5337ca3d114b4bea36549834c5965d02ddd9b91155732fe13d2b13311b08238b.jpeg"
  ],
  priceDollars: 9.8,
  description: "SUPERFOOD TEA BLEND\n\nSuperfoods & spice and everything nice! This nostalgic tea blend brings the sweet, spicy and cozy cookie feels with every soothing sip. Ginger, cinnamon, rooibos and vanilla sip like a treat, but are loaded with superfood benefits to keep you zen. \n\n100% ORGANIC - NUTRITIONIST FORMULATED - SUGAR FREE\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Drizzle with honey or maple syrup for a sweeter touch \n * Ice it: Steep it double strength and top with plenty of ice. Great with oat milk. \n * Cold-brew: Brew it overnight with cold water and add milk and honey. \nWhen to Steep:\n\n * When your digestion needs a little love \n * As an afternoon treat without the sugar.\n\n * When you are under stress.\n\n * As a cozy tea latte instead of your coffee. \n * When you are feeling under the weather. \n * As an after-dinner treat with honey. \n * To help wind-down before bed. \nCaffeine-free\n\n\n\n",
  tags: [],
  msrpDollars: 15.5,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:46.457Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
